import React from "react";
import { Route, Routes } from "react-router-dom";
import { AuthLayout } from "../components/authLayout";
import AlterarSenha from "../pages/alteracaoSenha";
import Home from "../pages/home";
import ExcluirConta from "../pages/excluirConta";
import Consentimentos from "../pages/consentimentos";

const AuthRoutes = () => {
  return (
    <AuthLayout>
      <Routes>
        <Route path="*" element={<Home />} />
        <Route path="/alterar-senha" element={<AlterarSenha />} />
        <Route path="/excluir-conta" element={<ExcluirConta />} />
        <Route path="/consentimentos" element={<Consentimentos />} />
      </Routes>
    </AuthLayout>
  );
};

export default AuthRoutes;
